import gsap, { Power1, Power2 } from 'gsap';
import { SplitText } from 'gsap/SplitText';

gsap.registerPlugin(SplitText);

import { GetBy } from '../_app/cuchillo/core/Element';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import VScroll_Item from '../_app/cuchillo/scroll/VScroll_Item';
import { Maths } from '../_app/cuchillo/utils/Maths';
import RedEye from '../3D/RedEye';

class ScrollItem__BillboardLight extends VScroll_Item {
  hasHiddenEnabled = false;
  xEye = .5;
  yEye = .5;
  //==================================================================================================================
  //          CONSTRUCTOR
  //==================================================================================================================

  constructor(__link, __index, __scroller) {
    super(__link, __index, __scroller);

    this.xEye = this.item.classList.contains("--left")? 0.1 : .5;
    this.yEye = this.item.classList.contains("--left")? 0.1 : .5;
    
    if(this.item.classList.contains("--left")) {
      RedEye.getInstance().doYellow();
    } else {
      RedEye.getInstance().doWhite();
    }

    this.onShow = () => {
      RedEye.getInstance().show();
      RedEye.getInstance().y = this.yEye;
      RedEye.getInstance().x = this.xEye;
    }
    this.onHide = () => {};
    this.onMove = () => {
      this.moveEye();
    }
  }

  moveEye() {
      let opacity = 1;
      if (this.progress >= .5) opacity = Maths.clamp(Maths.map(this.progress, .5, .9, 1, 0), 0, 1);    
      RedEye.getInstance().y = this.yEye - this.realY * .002;
      RedEye.getInstance().x = this.xEye;
  }

  dispose() {
    super.dispose();
    RedEye.getInstance().hide();
  }

  //==================================================================================================================
  //          PUBLIC
  //==================================================================================================================
}

Scroll._registerClass('billboard-light', ScrollItem__BillboardLight);
